import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

/**
 * Lista de torneos publicados (más recientes primero).
 * @param {object} opts - { limit, offset }
 */
export async function listarTorneos({ limit = 20, offset = 0 } = {}) {
  const res = await api.get("/tournaments", {
    params: { limit, offset, status: "published" },
  });
  return res.data; // { items, total }
}

/**
 * Obtiene un torneo por id con categorías, podios e imágenes.
 */
export async function obtenerTorneo(id) {
  const res = await api.get(`/tournaments/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarTorneosAdmin({ limit = 100, offset = 0 } = {}) {
  const res = await apiAuth.get("/tournaments/admin/all", {
    params: { limit, offset },
  });
  return res.data;
}

export async function obtenerInstitucionesResultados() {
  const res = await apiAuth.get("/tournaments/admin/institutions");
  return res.data;
}

export async function registrarInstitucionesResultados() {
  const res = await apiAuth.post("/tournaments/admin/institutions/register");
  return res.data;
}

/**
 * Crea un torneo con sus categorías y podios anidados.
 * @param {object} payload - { name, description?, location?, association?, organizer?, event_date, teams_4_points?, teams_3_points?, teams_total?, status?, categories: [{ name, city?, category_date?, note?, podiums: [{ position, player_name, club? }] }] }
 */
export async function crearTorneo(payload) {
  const res = await apiAuth.post("/tournaments", payload);
  return res.data;
}

export async function editarTorneo(id, payload) {
  const res = await apiAuth.put(`/tournaments/${id}`, payload);
  return res.data;
}

export async function eliminarTorneo(id) {
  const res = await apiAuth.delete(`/tournaments/${id}`);
  return res.data;
}

/* ============================================================
   CATEGORIES (catalog & admin)
   ============================================================ */

export async function listarCategoriasCatalogo() {
  const res = await api.get("/tournaments/categories/catalog");
  return res.data;
}

export async function crearCategoriaCatalogo(payload) {
  const res = await apiAuth.post("/tournaments/categories/catalog", payload);
  return res.data;
}

export async function editarCategoriaCatalogo(id, payload) {
  const res = await apiAuth.put(`/tournaments/categories/catalog/${id}`, payload);
  return res.data;
}

export async function eliminarCategoriaCatalogo(id) {
  const res = await apiAuth.delete(`/tournaments/categories/catalog/${id}`);
  return res.data;
}

export async function agregarCategoria(tournamentId, payload) {
  const res = await apiAuth.post(`/tournaments/${tournamentId}/categories`, payload);
  return res.data;
}

export async function editarCategoria(tournamentId, categoryId, payload) {
  const res = await apiAuth.put(`/tournaments/${tournamentId}/categories/${categoryId}`, payload);
  return res.data;
}

export async function eliminarCategoria(tournamentId, categoryId) {
  const res = await apiAuth.delete(`/tournaments/${tournamentId}/categories/${categoryId}`);
  return res.data;
}

/* ============================================================
   PODIUMS (admin)
   ============================================================ */

export async function agregarPodio(tournamentId, categoryId, payload) {
  const res = await apiAuth.post(
    `/tournaments/${tournamentId}/categories/${categoryId}/podiums`,
    payload,
  );
  return res.data;
}

export async function editarPodio(tournamentId, categoryId, podiumId, payload) {
  const res = await apiAuth.put(
    `/tournaments/${tournamentId}/categories/${categoryId}/podiums/${podiumId}`,
    payload,
  );
  return res.data;
}

export async function eliminarPodio(tournamentId, categoryId, podiumId) {
  const res = await apiAuth.delete(
    `/tournaments/${tournamentId}/categories/${categoryId}/podiums/${podiumId}`,
  );
  return res.data;
}

/* ============================================================
   GALLERY (admin)
   ============================================================ */

/**
 * Sube imágenes al torneo (las guarda en files polimórficos).
 */
export async function subirImagenesTorneo(tournamentId, files) {
  const formData = new FormData();
  const arr = Array.from(files);
  arr.forEach((f) => formData.append("files", f));

  const res = await apiAuth.post(`/tournaments/${tournamentId}/images`, formData);
  return res.data;
}

export async function marcarPortada(tournamentId, imageId) {
  const res = await apiAuth.put(`/tournaments/${tournamentId}/images/${imageId}/cover`);
  return res.data;
}

export async function eliminarImagenTorneo(tournamentId, imageId) {
  const res = await apiAuth.delete(`/tournaments/${tournamentId}/images/${imageId}`);
  return res.data;
}

export async function subirImagenesCategoria(tournamentId, categoryId, files) {
  const formData = new FormData();
  Array.from(files).forEach((f) => formData.append("files", f));

  const res = await apiAuth.post(
    `/tournaments/${tournamentId}/categories/${categoryId}/images`,
    formData,
  );
  return res.data;
}

export async function marcarPortadaCategoria(tournamentId, categoryId, imageId) {
  const res = await apiAuth.put(
    `/tournaments/${tournamentId}/categories/${categoryId}/images/${imageId}/cover`,
  );
  return res.data;
}

export async function eliminarImagenCategoria(tournamentId, categoryId, imageId) {
  const res = await apiAuth.delete(
    `/tournaments/${tournamentId}/categories/${categoryId}/images/${imageId}`,
  );
  return res.data;
}
